const getDisableDetails = (fraudCnt) => {
    let disabledReason = '';
    let description = '';

    switch (fraudCnt) {
        case 'Fraud Suspect Disabled':
            disabledReason = 'Disabled due to Onboarding Non-Compliance';
            description = 'Multiple complaints received against this seller from buyers, which is impacting our brand image, hence the listing has been removed. KYC documents required for profile evaluation.';
            break;
        case 'User do not want to be listed':
            disabledReason = 'User do not want to be listed';
            description = 'This account was disabled based on your request. KYC Process needs to be completed for profile re-activation.';
            break;
        case 'E-mail Bounce':
            disabledReason = 'E-mail Bounce';
            description = 'The account was disabled as our emails were not getting delivered on the email address mentioned in the account. KYC process needs to be completed for profile reactivation.';
            break;
        case 'Fraud complaint':
            disabledReason = 'Disabled due to Onboarding Non-Compliance';
            description = 'As per our records, your account is suspended due to compliance issues. One of the reasons could be complaints against you by other users in the past. KYC documents required for profile evaluation.';
            break;
        case 'Junk data':
            disabledReason = 'Junk data';
            description = 'KYC Process needs to be completed for profile re-activation';
            break;
        case 'Primary Mobile Claimed by another Gluser':
            disabledReason = 'Primary Mobile Claimed in Another Account';
            description = 'NA';
            break;
        case 'Multiple BS Conflict':
            disabledReason = 'Disabled due to Onboarding Non-Compliance';
            description = 'As per our records, your account is suspended due to compliance issues. One of the reasons could be complaints against you by other users in the past. KYC documents required for profile evaluation.';
            break;
        case 'Blacklisted User':
            disabledReason = 'Disabled due to Onboarding Non-Compliance';
            description = 'As per our records, your account is suspended due to compliance issues. One of the reasons could be complaints against you by other users in the past. KYC documents required for profile evaluation.';
            break;
        case 'Conflict Temporary Disable':
            disabledReason = 'Disabled due to Onboarding Non-Compliance';
            description = 'As per our records, your account is suspended due to a complaint from a user. KYC documents required for profile evaluation.';
            break;
        case 'Suspicious Activity':
            disabledReason = 'Suspicious Activity';
            description = 'Account has been temporarily suspended due to suspicious changes in the contact details in past few days. KYC documents required for profile evaluation along with proof that past complaints by Buyers have been resolved.';
            break;
        case 'Company Closed':
            disabledReason = 'Company Closed';
            description = 'This account was disabled as we were informed that the business has been shut down. KYC Process needs to be completed for profile re-activation. Also, need written confirmation from the customer stating the business is still active on email.';
            break;
        case 'Wrong Contact Details':
            disabledReason = 'Wrong Contact Details';
            description = 'Account was disabled due to incorrect contact information. KYC Process needs to be completed for profile re-activation.';
            break;
        case 'Against Our Content Policy':
            disabledReason = 'Disabled due to Onboarding Non-Compliance';
            description = 'Listing was suspended due to Content/Copyright related issues in the past. KYC Process needs to be completed for profile re-activation.';
            break;
        case 'No ECS Cleared':
            disabledReason = 'Continuous NACH/Monthly Payment Bounced (Initial)';
            description = 'Listing was suspended due to non-payment of monthly dues. As per the IndiaMART Policy, the account cannot be re-activated on monthly mode again.';
            break;
        default:
            disabledReason = 'NA';
            description = 'NA';
            break;
    }

    return { disabledReason, description };
};

export default getDisableDetails;  